/* eslint-disable */
/**
 *
 * UploadCameraMedia
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';

import './style.scss';

import reducer from './reducer';
import saga from './saga';
import {
  makeSelectUploadedFile,
  makeSelectLoading,
  makeSelectError,
  makeSelectUploadedFileType,
} from './selectors';
import { uploadCameraMediaFile, flushState } from './actions';


import moment from 'moment';
import { decode } from 'base64-arraybuffer';

// antd component
import { Button, Form, Upload, message } from 'antd';

// assets
import { ArrowRightOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

// capacitor lib
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

// utils
import {
  normFile,
  resizeFile,
  scrubFileName,
} from 'utils/uploadHelper';
import { appHelper } from 'appCapacitor/helpers';


export function UploadCameraMedia({
  name,
  media,
  showCamera,
  // props action
  uploadChange,
  setProgress,
  // states
  loading,
  error,
  uploadedFile,
  uploadFileType,
  // container actions
  uploadCameraMediaFile,
  flushState,
}) {
  useInjectReducer({ key: 'uploadCameraMedia', reducer });
  useInjectSaga({ key: 'uploadCameraMedia', saga });

  const [fileList, setFileList] = useState([]);

  const [cameraLoad, setCameraLoad] = useState(false);

  // Clearing the state after unmounting a component
  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
      flushState();
    };
  }, []);

  // When file is getting back to the server, we refresh the list + the parent
  useEffect(() => {
    if (uploadedFile) {
      if (uploadedFile.hasOwnProperty('url')) {
        setProgress(true);
        setCameraLoad(false);
        if (media.length > 0) {
          media.map(item => {
            if (item !== uploadedFile.url) {
              uploadChange([...media, uploadedFile.url]);
            }
          });
        } else {
          uploadChange([uploadedFile.url]);
        }
      } else {
        setCameraLoad(false);
        setProgress(false);
      }
    }
  }, [uploadedFile]);

  error &&
    message.error(`Quelque chose s'est mal passé. Essayer à nouveau.`, 2);

  // when file remove, we upload the filelist + the parent
  const fileOnRemove = file => {
    let newFileList = [];
    let newContent = [];
    for (let i = 0; i < fileList.length; i++) {
      if (file.uid !== fileList[i].uid) {
        newFileList.push(fileList[i]);
        newContent.push(fileList[i].url);
      }
    }
    setFileList(newFileList);
    uploadChange(newContent);
  };

  // Upload and Compress File
  const uploadCameraMediaFiles = file => {
    const formPayload = new FormData();

    const type = file.type.indexOf('image') > 0 ? 'image' : 'document';

    if (type === 'image') {
      // compress uploaded file
      resizeFile(file)
        // need to wait the image are compress
        .then(compressFile => {
          // change Blob to File
          let tempCompressFile = new File(
            [compressFile],
            scrubFileName(compressFile.name),
          );

          /**
           * Check if previous files have same name
           * if yes, add timestamp to the current file name
           */
          fileList.length > 0 &&
            fileList.map(propFile => {
              if (propFile.name === tempCompressFile.name) {
                tempCompressFile = new File(
                  [tempCompressFile],
                  scrubFileName(
                    `${tempCompressFile.lastModified}_${tempCompressFile.name}`,
                  ),
                );
              }
            });

          // add uploading file to array of all files
          tempCompressFile.status = 'uploading';
          setFileList([...fileList, tempCompressFile]);

          formPayload.append('file', tempCompressFile);

          uploadCameraMediaFile(formPayload, type);
        })
        .catch(err => {
          message.error(`Quelque chose s'est mal passé. Essayer à nouveau.`, 2);
        });
    }
    if (type === 'document' || (type === 'audio' || type === 'video')) {
      // change Blob to File
      let tempCompressFile = new File([file], scrubFileName(file.name));

      // add uploading file to array of all files
      tempCompressFile.status = 'uploading';
      setFileList([...fileList, tempCompressFile]);

      formPayload.append('file', tempCompressFile);

      uploadCameraMediaFile(formPayload, type);
    }
  };


  // Run Camera and get file
  const handleTakePhoto = async () => {
    if (!appHelper.isWeb) {
      const options = {
        source: CameraSource.Camera, // open only camera
        quality: 100,
        // allowEditing: true,
        resultType: CameraResultType.Base64, // CameraResultType.Uri
      };

      const cameraPhoto = await Camera.getPhoto(options);
      // originalPhoto.webPath will contain a path that can be set as an image src.
      // You can access the original file using image.path, which can be
      // passed to the Filesystem API to read the raw data of the image,
      // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
      // let photoPath = cameraPhoto.webPath;

      // set camera file load progress
      cameraPhoto.base64String && setCameraLoad(true);

      const blob = new Blob(
        [new Uint8Array(decode(cameraPhoto.base64String))],
        {
          type: `image/${cameraPhoto.format}`,
        },
      );

      const customFileName =
        `photo_proof_${cameraPhoto.format}_` + moment().unix();

      const file = new File([blob], customFileName, {
        lastModified: moment().unix(),
        type: blob.type,
      });

      file && uploadCameraMediaFiles(file);

    }
  };

  // render function
  return !appHelper.isWeb && (
    <Form.Item
      key={`${name}-camera`}
      className="proof-option-upload"
      name={name}
      getValueFromEvent={normFile}
    >
      
      <div
        className={`proof-upload-filed ${loading ? 'loading' : ''} ${error ? 'error' : ''}`}
      >
        <Button className="proof-option" onClick={handleTakePhoto}>
          <CustomIcons className="proof-option__icon" type="proof-photo" />
          <div className="proof-option__description">{`Prendre une photo de mon justificatif`}</div>
          <ArrowRightOutlined className="proof-option__arrow" />
        </Button>
      </div>

    </Form.Item>
  );
}

UploadCameraMedia.defaultProps = {
  name: 'upload_camera',
};
UploadCameraMedia.propTypes = {
  dispatch: PropTypes.func.isRequired,
  // props
  uploadChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  error: makeSelectError(),
  uploadedFile: makeSelectUploadedFile(),
  uploadFileType: makeSelectUploadedFileType(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    uploadCameraMediaFile: (file, fileType) =>
      dispatch(uploadCameraMediaFile(file, fileType)),
    flushState: () => dispatch(flushState()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(UploadCameraMedia);
